import { createTheme } from "@mui/material";
export const themeObj = {
  palette: {
    primary: {
      light: "#e8a639",
      main: "#274C7E",
      dark: "#4e4e4e",
      contrastText: "#ffffff",
    },
    danger: {
      main: "#dc3545",
      dark: "#dc3545",
    },
    success: {
      main: "#4caf50",
      dark: "#4caf50",
    },
  },
  typography: {
    fontFamily: ['Inter', 'sans-serif'].join(',')
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "0.9rem",
          padding: "12px 24px",
          minWidth: 120,
          textTransform: "none",
          "&.Mui-selected": {
            fontWeight: 700,
          },
        },
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        size: "medium",
      },
    },
    MuiChip: {
      defaultProps: {
        size: "medium",
      },
    },
  },
};

const theme = createTheme(themeObj);
export default theme;
